import tailwindConfig from '../../../tailwind.config.js'

const mobileScreen = tailwindConfig.theme.screens.lg.replace('px', '');

export default function(){
	const bannerIntroBlock = document.querySelector( '[data-js="banner-intro-block"]' )
	const bannerTitle      = document.querySelector( '[data-js="banner-title"]' )

	if ( bannerIntroBlock && bannerTitle && window.innerWidth >= mobileScreen ) {
		const bannerIntroBlockHeight = bannerIntroBlock.offsetHeight
		const bannerTitleHeight      = bannerTitle.offsetHeight
		const bannerIntroBlockTop    = bannerIntroBlock.offsetTop + bannerIntroBlockHeight
		const bannerTitleTop         = bannerTitle.offsetTop + bannerTitleHeight
		const titleBlockDiffTop      = bannerIntroBlockTop - bannerTitleTop

		bannerIntroBlock.style.marginTop = `-${titleBlockDiffTop}px`
	}
}